import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Icon } from '../Icon';
import { getPlanSaveLabel } from '../../shared/plan-helpers';
import styles from './SubscriptionCardV10.css';

const cx = classnames.bind(styles);

const FEATURES = [
    { id: 'questions', content: <>Personalized questions <strong>for 7 life chapters</strong></> },
    { id: 'voice', content: <><strong>Voice or text</strong> answers</> },
    { id: 'chapters', content: <>Answers become <strong>written chapters</strong></> },
    { id: 'ebook', content: <>Save as <strong>an ebook</strong></> },
    { id: 'cancel', content: <>Cancel <strong>anytime</strong></> },
    { id: 'access', content: <><strong>Keep access</strong> to everything you create</> }
];

function renderSubtitle(subscriptionData) {
    const weeks = subscriptionData.billingPeriod?.value;

    if (subscriptionData.trial) {
        return `${subscriptionData.trial.price} now, then ${subscriptionData.price} every ${weeks} weeks`;
    }

    return `${subscriptionData.price} every ${weeks} weeks`;
}

function SubscriptionCardV10({ subscriptionData, selectedSubscriptionData, selectSubscription, name = 'subscription-plan' }) {
    const isActive = subscriptionData.plan === selectedSubscriptionData.plan;
    const oldPrice = subscriptionData.displayOldPrice ?? subscriptionData.price;
    const newPrice = subscriptionData.trial?.price ?? subscriptionData.price;
    const hasOldPrice = oldPrice !== newPrice;
    const saveLabel = hasOldPrice && !subscriptionData.isDiscountBadgeHidden ? getPlanSaveLabel(subscriptionData) : null;

    return (
        <label className={cx('root', { active: isActive })}>
            <input
                type='radio'
                name={name}
                value={subscriptionData.plan}
                checked={isActive}
                onChange={() => selectSubscription(subscriptionData)}
                className={styles.input}
            />
            {subscriptionData.isPopular && (
                <div className={styles.popularBanner}>
                    <Icon name='starFilled' className={styles.starIcon} />
                    Best offer
                </div>
            )}
            <div className={styles.content}>
                <span className={styles.radio}>
                    <span className={styles.radioDot} />
                </span>
                <div className={styles.planInfo}>
                    <p className={styles.name}>{subscriptionData.membershipName ?? subscriptionData.name}</p>
                    <p className={styles.subtitle}>{renderSubtitle(subscriptionData)}</p>
                </div>
                <div className={styles.priceInfo}>
                    {hasOldPrice && <p className={styles.oldPrice}>{oldPrice}</p>}
                    <p className={styles.newPrice}>{newPrice}</p>
                    {Boolean(saveLabel) && <span className={styles.saveBadge}>{`SAVE ${saveLabel}`}</span>}
                </div>
            </div>
            {isActive && (
                <ul className={styles.features}>
                    {FEATURES.map(feature => (
                        <li key={feature.id} className={styles.feature}>
                            <Icon name='checkItemFilled' className={styles.featureIcon} />
                            <span>{feature.content}</span>
                        </li>
                    ))}
                </ul>
            )}
        </label>
    );
}

SubscriptionCardV10.propTypes = {
    subscriptionData: PropTypes.object.isRequired,
    selectedSubscriptionData: PropTypes.object.isRequired,
    selectSubscription: PropTypes.func.isRequired,
    name: PropTypes.string
};

export {
    SubscriptionCardV10
};
